import { FETCH_TEMPLATE_LIBRARY_DATA } from "./actionCreators"

const initStore = {
    templates: []
}

export const automationsReducer = (store = initStore, action) => {
    const { type, payload } = action
    switch (type) {
        case `${FETCH_TEMPLATE_LIBRARY_DATA}_SUCCESS`: {
            const { data } = payload;
            return {
                ...store,
                templates: data
            }
        }
        default: return store;
    }
}